module.exports = __webpack_public_path__ + "media/images/sign_bord-801d30ef00b9c6084fa92c4662837a08.svg";